import { Autocomplete, Checkbox, Grid, TextField } from '@mui/material';
import { MdCheckBox, MdCheckBoxOutlineBlank, MdDelete } from 'react-icons/md';
import { useSelector } from 'react-redux';

import { MultiSelectDoneButton } from 'GeminiViewerComponent/components/MultiSelectDoneButton';
import { selectDefaultTheme } from 'GeminiViewerComponent/features/globals/themeSlice';
import { getNewsFlashDisplayOptions } from 'GeminiViewerComponent/features/newsFlash/newsFlashSlice';
import useStyles from '../../../styles';

const DisplayOptionFilter = ({
    debouncedSearch,
    searchString,
    startDate,
    endDate,
    displayOptionId,
    setDisplayOptionId,
}) => {
    //#region Constants
    //#endregion Constants

    //#region Hooks
    //#endregion Hooks

    //#region State
    //#endregion State

    //#region Selectors
    const theme = useSelector(selectDefaultTheme);
    const newsFlashDisplayOptions = useSelector(getNewsFlashDisplayOptions);
    const classes = useStyles(theme);
    //#endregion Selectors

    //#region Refs
    //#endregion Refs

    //#region Effects
    //#endregion Effects

    //#region Methods
    //#endregion Methods

    //#region Render time calcs
    //#endregion Render time calcs

    return (
        <Grid item={true} xs={12} md={6} lg={6} className={classes.customSelect}>
            <Autocomplete
                variant="outline"
                limitTags={2}
                multiple
                id="news_flash_display_option"
                options={newsFlashDisplayOptions || []}
                clearIcon={<MdDelete fontSize="18" />}
                onChange={(_, newInputValue) => {
                    setDisplayOptionId(newInputValue);
                    const array = newInputValue.map((item) => item.news_flash_display_option_id);
                    debouncedSearch(searchString, startDate, endDate, array);
                }}
                PaperComponent={MultiSelectDoneButton}
                disableCloseOnSelect
                value={displayOptionId}
                getOptionLabel={(option) => option.display_name}
                renderOption={(props, option, { selected }) => (
                    <li
                        {...props}
                        key={option.news_flash_display_option_id}
                        style={{
                            padding: '0',
                        }}
                    >
                        <Checkbox
                            icon={<MdCheckBoxOutlineBlank className="react-icon" />}
                            checkedIcon={<MdCheckBox className="react-icon" />}
                            style={{
                                marginRight: 8,
                            }}
                            checked={selected}
                        />
                        {option.display_name}
                    </li>
                )}
                renderInput={(params) => (
                    <TextField {...params} variant="outlined" label="Display Options" placeholder="Display Options" />
                )}
            />
        </Grid>
    );
};

export { DisplayOptionFilter };
